export enum OrganizationOwnerStaticActionType {
  Delete = 'delete',
}
